import axios from 'axios'
import { Message } from 'element-ui'
//import imgCompressUtil from './imgCompressUtil';//压缩图片的js
// status 可以操作状态
export function formatOrderStatus (status) {
  switch (status) {
    case 0:
      return '待审核'
    case 1:
      return '出单中'
    case 2:
      return '应收'
    case 3:
      return '已完成'
    case 4:
      return '取消'
    case 5:
      return '退保'
    case 6:
      return '已核保待支付'
    case 7:
      return '下发修改'
    case 8:
      return '已支付待实收'
    case 11:
      return '二级核保中'
    case 12:
      return '等待人工核保'
    case 13:
      return '退保待处理'
    case 14:
      return '退保待审核'
    case 15:
      return '保单替换'
  }

}

export function getRepayStatus (pay_type) {
    switch (pay_type) {
        case "1":
            return '银行卡'
        case "2":
            return '支付宝'
        case "3":
            return '微信'
        case "4":
            return '信用卡'
        case "5":
            return '现金'
        default:
            return '未知'

    }
}

export function orderStatus()
{
   var orderstatus =[
  {
    id:0,
    name:'待审核'
  },
  {
    id:1,
    name:'出单中'
  },
  {
    id:2,
    name:'应收'
  },
  {
    id:4,
    name:'取消'
  },
  {
    id:6,
    name:'已核保待支付'
  }
  ,{
    id:7,
    name:"下发修改"
  },
   {
   id:8,
   name:"已支付待实收"
  },
  {
    id:11,
    name:'二级核保中'
  },
  {
    id:12,
    name:'等待人工核保'
  },
  {
     id:13,
     name:'退保待处理'
  },
  {
     id:14,
     name:'退保待审核'
  },
];
return orderstatus;
}

//图片上传
export async function uploadFile(item,type=1){
    let furl = '';
    //------上传到阿里云
    let carFd = new FormData()
    carFd.append('file', item.raw)
    carFd.append('file_type', type)//类型：1行驶证2营业执照3身份证4保单5支付凭证6佣金凭证 8车辆绑定的商业险保单信息9运输公司绑定的投保声明信息)
    carFd.append('file_value',item.raw.id)
    carFd.append('company_id', sessionStorage.getItem('company_id'))
    carFd.append('access_token', sessionStorage.getItem('token'))

    await axios.post('api/'+'sys.oss_upload/uploadFile', carFd).then(res11 => {
      console.log('uploadfile',res11)
      if (res11.data.code == 200) {
        console.log('333file_url--------',res11.data.data.src)
        furl =  res11.data.data.src;
      } else if (res11.data.code == 1) {
        Message.error(res11.data.msg)
        return false;
      }
    }).catch(function (error) {
      Message.error(error.msg)
      console.log(error);
      return false;
    })
    console.log('444file_url---',furl);
    return furl;
    //------上传到阿里云

}
export function getTuiBaoType(tuibaoType)
{
    switch (tuibaoType) {
        case 1:
            return '按天退保'
        case 2:
            return '按月退保（十个月）'
        case 3:
            return '按月退保（十二个月）'
        default:
            return '无'
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils/index.js